import { useNavigate } from "react-router-dom";
import { TabMenu, TabMenuData } from "../../components/tabMenu/TabMenu";
import { useEffect } from "react";
import { isGoalSettingOpen } from "../../config/config";

export const GoalSettingTabMenu = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isGoalSettingOpen)
      navigate("/overview/total-emissions", { replace: true });
  }, [isGoalSettingOpen]);

  const tabMenu: TabMenuData[] = [
    { pathname: "/goal-setting/dashboard", name: "Dashboard" },
    { pathname: "/goal-setting/add-goal", name: "Goal" },
  ];

  return <TabMenu tabMenuData={tabMenu} />;
};
